import classNames from 'classnames';
import type React from 'react';

import './Spinner.scss';

interface SpinnerProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children?: React.ReactNode;
  className?: string;
}

const Spinner = ({ children, className, ...rest }: SpinnerProps) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={classNames('Spinner', className)}
      data-testid="spinner"
      {...rest}
    >
      <span className="sr-only">Loading...</span>
      {children}
    </div>
  );
};

export { Spinner };
